<template>
<main class="l-contents mt-4">
    <div class="title1 text-center">
        <h2 class="title1_title"><span class="title1_mainLabel" v-t="'aboutCookie.title'"></span></h2>
    </div>
    <table class="table1">
        <tbody>
            <tr>
                <th class="commom-custom" colspan="2" v-t="'aboutCookie.cookieTitle'"></th>
            </tr>
            <tr>
                <td class="is-type1 commom-custom"></td>
                <td class="commom-custom" v-t="'aboutCookie.cookieContent'">
                </td>
            </tr>
            <tr>
                <th class="commom-custom" colspan="2" v-t="'aboutCookie.useOfCookieTitle'"></th>
            </tr>
            <tr>
                <td class="is-type1 commom-custom"></td>
                <td class="commom-custom" v-t="'aboutCookie.useOfCookieContent'">
                </td>
            </tr>
            <tr>
                <td class="is-type1 commom-custom"></td>
                <td class="commom-custom" v-t="'aboutCookie.useOfCookieSubTitle_1'"></td>
            </tr>
            <tr>
                <td class="is-type1 commom-custom"></td>
                <td class="commom-custom" v-t="'aboutCookie.useOfCookieSubContent_1'" style="padding-left: 40px;">
                </td>
            </tr>
            <tr>
                <td class="is-type1 commom-custom"></td>
                <td class="commom-custom" v-t="'aboutCookie.useOfCookieSubTitle_2'"></td>
            </tr>
            <tr>
                <td class="is-type1 commom-custom"></td>
                <td class="commom-custom" v-t="'aboutCookie.useOfCookieSubContent_2'" style="padding-left: 40px;">
                </td>
            </tr>
            <tr>
                <th class="commom-custom" colspan="2" v-t="'aboutCookie.googleAnalyticsTitle'"></th>
            </tr>
            <tr>
                <td class="commom-custom"></td>
                <td class="commom-custom" v-t="'aboutCookie.googleAnalyticsContent'">
                </td>
            </tr>
        </tbody>
    </table>
</main>
</template>

<script>
export default {
    name: 'AboutCookie'
}
</script>

<style lang="scss">
.commom-custom{
    border: unset !important;
    padding: 0px;
};
</style>
